import { asyncControllerAmbassadorRequest } from '../../../services/asyncController/asyncControllerAmbassadorRequest';
import {
  applyCouponToOrder,
  joinParticipant,
  removeCouponFromOrder,
} from '@wix/ambassador-challenges-v1-participant/http';
import { getMyMember } from '@wix/ambassador-members-v1-member/http';
import { defaultErrorOptions } from '../../../utils/defaultErrorOptions';
import {
  arrayToObjectAsync,
  getBaseProvidersData,
} from '../../../contexts/main/getBaseProvidersData';
import { getChallengeInitialData } from '../../../contexts/storage-contexts/Challenge';
import { Referrer } from '../../../contexts/storage/referrer';
import { userProviderPropsMap } from '../../../contexts/User/userProviderPropsMap';
import { coupons } from './coupons';
import { getTermsAndConditionsUrl } from './getTermsAndConditionsUrl';
import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { ISinglePaymentPageProps } from '../Widget/interfaces';

export const getInitialProps = async (
  flowAPI: ControllerFlowAPI,
): Promise<ISinglePaymentPageProps> => {
  const t = flowAPI.translations.t;

  return {
    applyCouponToOrder: asyncControllerAmbassadorRequest(applyCouponToOrder, {
      errorCodesMap: {
        applicationError: {
          ERROR_COUPON_DOES_NOT_EXIST: () => {
            return { message: t('coupons.form.error.doesnt-exist') };
          },
          payment_error: () => {
            return { message: t('coupons.form.error.already-applied') };
          },
          ERROR_COUPON_IS_ALREADY_APPLIED: () => {
            return {
              message: t('coupons.form.error.already-applied'),
            };
          },
        },
      },
    }),
    getMyMember: asyncControllerAmbassadorRequest(
      getMyMember,
      defaultErrorOptions,
    ),
    removeCouponFromOrder: asyncControllerAmbassadorRequest(
      removeCouponFromOrder,
      defaultErrorOptions,
    ),
    joinParticipant: asyncControllerAmbassadorRequest(
      joinParticipant,
      defaultErrorOptions,
    ),
    ...(await arrayToObjectAsync([
      getBaseProvidersData({
        flowAPI,
      }),
      getChallengeInitialData(flowAPI, Referrer.PAYMENT_PAGE),
      userProviderPropsMap(flowAPI),
      coupons(flowAPI),
      getTermsAndConditionsUrl(flowAPI),
    ])),
  };
};
